import { Col, Row } from "antd";
// import { useState } from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
// import ReactPlayer from "react-player";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import styles from "./QualityAuthenticity.module.scss";
import ali from "./images/abas.png";
import preeti from "./images/preeti.png";
import qms from "./images/qms.svg";
import quality_video from "./images/quality_video.svg";

const QualityAuthenticity = () => {
    // const [modalVisible, setModalVisible] = useState(false);
    // function showModal() {
    //     setModalVisible(true);
    // }

    // function hideModal() {
    //     setModalVisible(false);
    // }
    return (
        <Layout title="Quality & Authenticity">
            <div className={`${styles.wrapper} container`}>
                {window.innerWidth < 991 ? (
                    <BreadCrumb
                        list={[
                            { name: "Home", link: "/" },
                            {
                                name: "Quality & Authenticity",
                                link: "/quality-authenticity",
                            },
                        ]}
                    />
                ) : (
                    <BreadCrumb
                        list={[
                            { name: "Back to Home", link: "/" },
                            {
                                name: "Quality & Authenticity",
                                link: "/quality-authenticity",
                            },
                        ]}
                    />
                )}

                <div className={styles.quality_content_wrapper}>
                    <div className={styles.title}>We check, verify & authenticate every item</div>

                    <div className={styles.subtitle}>
                        {" "}
                        <strong>Quality Matters,</strong> At Desi Fresh, our expert food safety and quality team leaves no stone unturned to
                        bring you only the best. We authenticate every item with the utmost care and precision, ensuring it meets our high
                        standards before it reaches your plate. Experience the taste of assurance with Desi Fresh
                    </div>

                    <div className={styles.video_modal}>
                        <img
                            src={quality_video}
                            alt="ret_ref_video"
                            className={styles.ret_ins_img}
                            // onClick={showModal}
                        />
                        {/* <VideoModal visible={modalVisible} onCancel={hideModal} /> */}
                    </div>

                    {/* <div className={styles.language_sel}>
                        <Select
                            defaultValue="en"
                            style={{ width: 120, marginBottom: 20 }}
                            options={[
                                { label: "English", value: "en" },
                                { label: "German", value: "de" },
                            ]}
                        />
                    </div> */}

                    {/* Quality Commitment */}
                    <div className={styles.q_com}>
                        <div className={styles.q_com_title}>Quality Commitment</div>
                        <div className={styles.q_com_para} style={{ marginBottom: 10 }}>
                            <strong>"Quality at the Heart of Desi Fresh:</strong> A Dedication to Safe and Flavorful Shopping"
                        </div>
                        <div className={styles.q_com_para}>
                            "At Desi Fresh, we're driven by a passion for quality and a commitment to food safety. Our core values of
                            transparency, safety, integrity, customer focus, and employee empowerment guide us every step of the way. We're
                            constantly improving our food safety & quality management system, meeting all requirements, and building a
                            culture of stewardship. Trust us to deliver an exceptional shopping experience, filled with the flavors and
                            aromas of the world, every time you visit Desi Fresh."
                        </div>
                        <div className={styles.q_com_img}>
                            <img src={qms} alt="qms" />
                        </div>
                    </div>

                    {/* Meet Quality Experts */}
                    <div className={styles.mqe}>
                        <div className={styles.mqe_title}>Meet Our Quality Experts</div>
                        <div className={styles.mqe_para}>
                            "At Desi Fresh, we believe that quality is a team effort. That's why we're proud to introduce you to the experts
                            behind our commitment to safe and delicious shopping. Our quality experts are dedicated to ensuring every item
                            on our shelves meets the highest standards, so you can taste the difference with every bite. Get to know the
                            taste makers of Desi Fresh and experience the joy of multicultural grocery shopping like never before."
                        </div>
                        <br />

                        <Row gutter={[10, 10]}>
                            <Col xs={24} lg={4}>
                                <div className={styles.p_s}>
                                    <img src={preeti} alt="preeti" />
                                    <div>
                                        {" "}
                                        <strong>Dr. Preeti Singh,</strong> Ph.D
                                    </div>
                                    <div style={{ marginBottom: 5 }}>Founder & CEO</div>
                                    <div className={styles.ps_social}>
                                        <a href="https://www.linkedin.com/in/preeti-singh-0b0b4a1/">
                                            <FaLinkedinIn size={20} />
                                        </a>

                                        <a href="mailto:">
                                            <GrMail size={20} />
                                        </a>
                                    </div>
                                </div>
                            </Col>

                            <Col xs={24} lg={20}>
                                <div className={styles.bio_g}>Biography</div>

                                <p className={styles.bio_para}>"Dr. Preeti Wani: A Pioneer in Food Technology and Quality Control"</p>
                                <p className={styles.bio_para}>
                                    "With a Ph.D. in Dairy Technology, Dr. Preeti Wani is a highly respected and accomplished professional
                                    in the world of food safety. Throughout her career, she has honed her expertise at esteemed
                                    organizations such as the Defence Food Research Laboratory in India, the Technical University of Munich,
                                    and the Fraunhofer Institute for Process Engineering & Packaging IVV. Additionally, her expertise as a
                                    food industry consultant has helped multiple companies improve their quality control, packaging, hygiene
                                    and more. Dr. Wani also plays a crucial role as an editor for Food Packaging and Shelf Life Journal,
                                    advancing research on quality control through better packaging practices. She is a certified Lead
                                    Auditor for several standards, including ISO 9001, BRC Food, FSSC 22000, ISO22000 and HACCP level 4,
                                    making her a sought-after expert in the field."
                                </p>
                            </Col>
                        </Row>
                        <br />
                        <Row gutter={[10, 10]}>
                            <Col xs={24} lg={4}>
                                <div className={styles.p_s}>
                                    <img src={ali} alt="ali" />
                                    <div>
                                        <strong>Dr. Ali Abas Wani,</strong> Ph.D, MBA
                                    </div>
                                    <div style={{ marginBottom: 5 }}>Co- Founder & COO</div>
                                    <div className={styles.ps_social}>
                                        <a href="https://www.linkedin.com/in/aa">
                                            <FaLinkedinIn size={20} />
                                        </a>

                                        <a href="mailto:">
                                            <GrMail size={20} />
                                        </a>
                                    </div>
                                </div>
                            </Col>

                            <Col xs={24} lg={20}>
                                <div className={styles.bio_g}>Biography</div>

                                <p className={styles.bio_para}>
                                    "With a passion for making a difference, Dr. Ali Abas Wani is a renowned food industry consultant,
                                    specializing in food product innovation, consumer health, and food traceability. Bringing over 25 years
                                    of expertise to the table, Dr. Wani earned his M.Sc & Ph.D in Food Technology and rounded out his
                                    education with an Executive MBA from ESSEC & Mannheim Business Schools in France & Germany. Prior to
                                    co-founding Desi Fresh, Dr. Wani served as a Professor at an Indian University and as a Principal
                                    Scientist at the Fraunhofer Institute for Process Engineering & Packaging IVV in Germany. In addition to
                                    his work at Desi Fresh, he continues to consult on innovation, consumer health, and food traceability.
                                    Dr. Wani is also the Editor-in-Chief of Food Packaging & Shelf Life magazine and serves as the regional
                                    Chair for the India European Hygienic Design Group (EHEDG). His dedication to education and improving
                                    access to healthy foods through innovation make him a driving force in the food industry."
                                </p>
                            </Col>
                        </Row>
                        <br />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default QualityAuthenticity;

// do not delete this commented code
// const VideoModal = ({ visible, onCancel }) => {
//     return (
//         <Modal open={visible} onCancel={onCancel} footer={null} destroyOnClose closable={null} bodyStyle={{ padding: 0 }} centered>
//             <div
//                 style={{
//                     position: "relative",
//                     paddingBottom: "56.25%" /* 16:9 */,
//                 }}
//             >
//                 <ReactPlayer
//                     style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                     }}
//                     url="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
//                     width="100%"
//                     height="100%"
//                     muted={true}
//                     playing={true}
//                     controls={true}
//                 />
//             </div>
//         </Modal>
//     );
// };
